import styled from 'styled-components';

import {
    ButtonGroup,
} from '@zillow/constellation';

export const StyledButtonGroup = styled(ButtonGroup)`
    display: flex;
    justify-content: flex-end;
`;

export const StyledAlertText = styled.div`
    display: flex;
    align-items: center;
`;
